import React from 'react';
import PropTypes from 'prop-types';
import AreaChart from './areaChart';
import options from '../chartOptions';
import moment from 'moment';
import Loader from './ui/Loader';

class DashboardEngagement extends React.Component{

    getCounts = (arr) => {
        const dates = [];
        const values = [];
        let firstDate = moment( Number(arr[0])).format('YYYY-MM');
        while( moment(firstDate, "YYYY-MM").isSameOrBefore( moment(), 'month' ) ){
            dates.push( firstDate );
            values.push(0);
            firstDate = moment(firstDate, "YYYY-MM").add(1, 'months').format("YYYY-MM");
        }

        arr.forEach(function(val, index){
            var dateIndex = dates.indexOf( moment( Number(val) ).format("YYYY-MM") );
            values[dateIndex] ++;
        });

        return {dates, values};
    };

    renderSales = () => {
        if(this.props.payments && this.props.payments.values && this.props.payments.dates){
            let data;
            let opt = {...options.salesOptions};
            data = {
                labels: this.props.payments.dates,
                datasets: [{
                    data: this.props.payments.values,
                    label: "£",
                    borderColor: "#b35bab",
                    backgroundColor: "rgba(179, 91, 171, 0.25)",
                    fill: true,
                    borderWidth: 2,
                    pointRadius: 0.25
                  }
                ]
            };

            return <AreaChart chartData={data} chartOptions={opt}/>;
        }
        else {
            return <Loader />;
        }
    };

    renderNKlogins = () => {
        if(this.props.user && this.props.user._NKLogins && this.props.user._NKLogins.length){
            const opt = {...options.countOptions};
            opt.title.text = 'NK logins over time';
            const count = this.getCounts(this.props.user._NKLogins);

            let data = {
                labels: count.dates,
                datasets: [{
                    data: count.values,
                    label: "Logins",
                    borderColor: "#b35bab",
                    backgroundColor: "rgba(179, 91, 171, 0.25)",
                    fill: true,
                    borderWidth: 2,
                    pointRadius: 0.25
                  }
                ]
            };

            return <AreaChart chartData={data} chartOptions={opt}/>;
        }
        else {
            return <Loader />;
        }
    };

    renderLiveEventLogins = () => {
        if(this.props.user && this.props.user._Liveeventlogins && this.props.user._Liveeventlogins.length){
            const opt = {...options.countOptions};
            opt.title.text = 'Live event logins over time';
            const count = this.getCounts(this.props.user._Liveeventlogins);

            let data = {
                labels: count.dates,
                datasets: [{
                    data: count.values,
                    label: "Logins",
                    borderColor: "#b35bab",
                    backgroundColor: "rgba(179, 91, 171, 0.25)",
                    fill: true,
                    borderWidth: 2,
                    pointRadius: 0.25
                  }
                ]
            };

            return <AreaChart chartData={data} chartOptions={opt}/>;
        }
        else {
            return <Loader />;
        }
    };

    renderLTV = () => {
        if(this.props.payments && this.props.payments.totalValue){
            return (
                <div className="meta">
                    <span>Lifetime value</span>
                    { this.props.payments.totalValue.toLocaleString("en-GB",{style:"currency", currency:"GBP"}) }
                </div>
            );
        }
        return <Loader />;
    };

    renderRecentValue = () => {

        if(this.props.payments && this.props.payments.values && this.props.payments.values.length){
            let val = 0;
            const length = this.props.payments.values.length;
            for(let i = (length-1); i > (length - 4) && i > 0; i--){
                val += this.props.payments.values[i];
            }
            return (
                <div className="meta">
                    <span>Sales in last 3 months</span>
                    { val.toLocaleString("en-GB",{style:"currency", currency:"GBP"}) }
                </div>
            );
        }
        return null;
    };

    render() {

        return (
            <div className="tab-panel charts">
                <div className="chart">
                    { this.renderLTV() }
                    { this.renderRecentValue() }
                </div>

                <div className="chart">
                    <h5 className="chartTitle">Sales over time</h5>
                    { this.renderSales() }
                </div>

                <div className="chart">
                    <h5 className="chartTitle">NK logins</h5>
                    { this.renderNKlogins() }
                </div>

                <div className="chart">
                    <h5 className="chartTitle">Live events attended</h5>
                    { this.renderLiveEventLogins() }
                </div>
            </div>
        );
    }
}

DashboardEngagement.propTypes = {
    user: PropTypes.object.isRequired
}

export default DashboardEngagement;


/** WEBPACK FOOTER **
 ** ./src/components/DashboardEngagement.js
 **/